// Libs
import React, { useState, useEffect } from 'react';

// Own Libs
import { GridView } from '@digital/ui';

//Api
import { getCrfFechamentoReportPerformaceProject } from '@app/api/crf/crffechamento';
import { CrfTabelaProjetoOverViewResult } from '@app/api/crf/crftabelaProjetoOverView';

//Files
import TabelaProjetoOverviewResumo from '../Dashboard/ProjectsOverview/tabelaProjetoOverviewResumo';

//Utils

interface IFechamentoProjetoOverViewProps {
    fechamentoId: string;
}

const CrfFechamentoProjetoOverView = (props: IFechamentoProjetoOverViewProps) => {

    const { fechamentoId } = props;
    const [resultProjetoOverView, setResultProjetoOverView] = useState<CrfTabelaProjetoOverViewResult[]>()


    useEffect(() => {
        if (fechamentoId) {
            getCrfFechamentoReportPerformaceProject(fechamentoId).then((data) => {
                setResultProjetoOverView(data);
            });
        }
    }, [fechamentoId]);

    return (
        <GridView noform>
            <GridView icon="files-new_by_copy" id={`detalhe`} noform title="PROJECTS | APPROVED">
                <TabelaProjetoOverviewResumo
                    dataSourceResult={resultProjetoOverView}
                    telaFechamento={true}
                    fechamentoId={fechamentoId}
                />
            </GridView>
        </GridView>
    );

}

export default CrfFechamentoProjetoOverView;